import i18next from 'i18next';

import { STORE_DUPLICATION_TYPE } from './getStoreSettingsCardSettings';

/**
 * Settings card of a central kitchen, holding the "set up products and recipes from a clone"
 * action. The action is disabled once the central kitchen already supplies a catalog, to avoid
 * cloning onto an existing one.
 */
const getCentralKitchenSettingsCardSettings = (centralKitchenSettings, isCloneDisabled) => {
  const { productsAndRecipesReferenceStoreName } = centralKitchenSettings;

  return {
    title: i18next.t('BACKOFFICE.STORES.SETTINGS'),
    inputs: [
      {
        isTextContent: true,
        textContent: productsAndRecipesReferenceStoreName
          ? i18next.t('BACKOFFICE.STORES.CENTRAL_KITCHEN_SETTINGS_DESCRIPTION_SELECTED', {
              storeName: productsAndRecipesReferenceStoreName,
            })
          : i18next.t('BACKOFFICE.STORES.CENTRAL_KITCHEN_SETTINGS_DESCRIPTION'),
      },
      {
        icon: '/images/inpulse/clone-black.svg',
        isCloneButton: true,
        label: i18next.t('BACKOFFICE.STORES.LIST_ACTION_CLONE_PRODUCTS_AND_RECIPES'),
        propertyKey: STORE_DUPLICATION_TYPE.PRODUCTS_AND_RECIPES,
        isDisabled: isCloneDisabled,
        disabledTooltipText: i18next.t(
          'BACKOFFICE.STORES.CENTRAL_KITCHEN_SETTINGS_CLONE_DISABLED_TOOLTIP',
        ),
      },
    ],
  };
};

export default getCentralKitchenSettingsCardSettings;
